import React, { useEffect, useRef } from 'react';

const NoiseTexture = () => {
  const canvasRef = useRef(null);

  const generateNoise = (ctx, width, height) => {
    const imageData = ctx.createImageData(width, height);
    const data = imageData.data;

    // Create organic, film-like grain with varying sizes
    for (let y = 0; y < height; y++) {
      for (let x = 0; x < width; x++) {
        const idx = (y * width + x) * 4;
        
        // Mix of fine and coarse random noise for organic feel
        const fine = Math.random();
        const coarse = Math.random() * 0.3;
        const medium = Math.random() * 0.5;
        
        // Combine with slight bias towards mid-tones
        const combined = (fine * 0.6 + medium * 0.3 + coarse * 0.1);
        const value = Math.floor(combined * 255);
        
        data[idx] = value;     // R
        data[idx + 1] = value; // G
        data[idx + 2] = value; // B
        data[idx + 3] = 30;    // A - subtle
      }
    }

    ctx.putImageData(imageData, 0, 0);
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const width = window.innerWidth;
    const height = window.innerHeight;

    canvas.width = width;
    canvas.height = height;

    generateNoise(ctx, width, height);

    // Handle resize
    const handleResize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      generateNoise(ctx, canvas.width, canvas.height);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 2,
        mixBlendMode: 'overlay',
        opacity: 0.8
      }}
    />
  );
};

export default NoiseTexture;
